import React, { useContext, useEffect, useMemo, useState } from 'react'
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarContent } from 'react-pro-sidebar'
import {
    FaTachometerAlt,
    FaUserAlt,
    FaVial,
    FaDna,
    FaFileAlt,
    FaRegAddressCard,
    FaHospitalAlt,
    FaBuilding,
    FaHospitalUser,
    FaClipboardCheck,
    FaBorderAll,
    FaSyringe,
    FaShieldVirus,
    FaRegSquare,
    FaCheckCircle,
    FaChessBoard,
    FaChartLine,
    FaFileInvoiceDollar,
    FaBarcode,
    FaChartBar,
    FaRegBuilding,
    FaPython,
    FaBook,
    FaSkull,
    FaTasks,
    FaBoxes,
    FaArrowDown,
    FaMale,
} from 'react-icons/fa'
import * as H from 'history'

import Logo from 'components/../../public/logo_h.png'
import LogoRCE from 'components/../../public/logo_rce.png'
import { useGroupApi } from 'api/group_by'
import { BaseSearchForm } from 'entities'
import { useForm } from 'utils/hooks'
import { INSPECTION_STATUS, SampleStatus, SAMPLE_STATUS } from 'entities/sample'
import { Badge } from 'react-bootstrap'
import { BsBook } from 'react-icons/bs'
import { MdOutlineInventory2 } from 'react-icons/md'
import { Flex } from './flex'
import { GlobalStateContext } from 'contexts/global_state_context'
import { MasterDataContext } from 'contexts/master_data_context'
import { BiSwim } from 'react-icons/bi'

type Props = {
    collapsed: boolean
    history: H.History
}
const Aside = (props: Props) => {
    // const [toggled, setToggled] = useState<boolean>(true)
    const [current, setCurrent] = useState<number>(0)
    const masterData = useContext(MasterDataContext)

    const globalState = useContext(GlobalStateContext)
    const sampleStatusGroupSearchForm = useForm<BaseSearchForm>({ groupBy: 'status', aggregate: 'Count("status")', aggregateAlias: 'count' })
    const sampleStatusGroupApi = useGroupApi('samples', sampleStatusGroupSearchForm)
    const inspectionStatusGroupSearchForm = useForm<BaseSearchForm>({
        groupBy: 'inspection_status',
        aggregate: 'Count("inspection_status")',
        aggregateAlias: 'count',
    })
    const inspectionStatusGroupApi = useGroupApi('samples', inspectionStatusGroupSearchForm)
    const isHomeTest = !!process.env.REACT_APP_IS_HOME_TEST
    const isVender = !!process.env.REACT_APP_IS_VENDOR

    useEffect(() => {
        sampleStatusGroupApi.execute()
        inspectionStatusGroupApi.execute()
        const elem: any = document.getElementsByClassName('pro-sidebar-inner')
        if (elem) {
            if (process.env.REACT_APP_ENV === 'staging') {
                elem[0]!.style.background = '#333'
            }
        }
    }, [])

    const stopPropagation = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, onClick: () => void) => {
        onClick()
        e.stopPropagation()
        e.preventDefault()
    }

    const inspectionStatusGroupData = useMemo(() => {
        return INSPECTION_STATUS.map((status) => {
            const obj = inspectionStatusGroupApi.response.groups?.find((obj) => {
                return obj.inspectionStatus === status
            })
            if (!obj) {
                return { name: status, count: 0 }
            }
            return { name: status, count: obj.count }
        })
    }, [inspectionStatusGroupApi.loading])

    const sampleStatusGroupData = useMemo(() => {
        const statuses = SAMPLE_STATUS
        statuses.splice(8, 1)
        return statuses.map((status) => {
            const obj = sampleStatusGroupApi.response.groups?.find((obj) => {
                return obj.status === status
            })
            if (!obj) {
                return { name: status, count: 0 }
            }
            return { name: status, count: obj.count }
        })
    }, [sampleStatusGroupApi.loading])

    const craifAppContent = (
        <>
            <Menu iconShape="circle">
                <Menu iconShape="circle">
                    <MenuItem
                        icon={<FaTachometerAlt />}
                        onClick={() => {
                            props.history.push('/dashboards')
                        }}
                    >
                        ダッシュボード
                    </MenuItem>
                </Menu>
                {globalState.user.isSuperuser && (
                    <Menu iconShape="circle">
                        <MenuItem
                            icon={<FaMale />}
                            onClick={() => {
                                props.history.push('/user_search')
                            }}
                        >
                            ユーザー検索
                        </MenuItem>
                    </Menu>
                )}
                <Menu iconShape="circle" style={{ display: isHomeTest ? 'none' : 'block' }}>
                    <SubMenu title={'やることリスト'} open={current === 1} icon={<FaTasks />} onClick={() => (current === 1 ? setCurrent(0) : setCurrent(1))}>
                        <MenuItem
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/task_sets?incomplete=true&kind=MATERIAL'))
                            }}
                            suffix={masterData.taskSets.length > 0 && <Badge bg={'danger'}>{masterData.taskSets.length}</Badge>}
                        >
                            資材発送
                        </MenuItem>
                    </SubMenu>
                </Menu>

                {isHomeTest ? (
                    <Menu iconShape="circle">
                        <MenuItem
                            icon={<FaBoxes />}
                            onClick={() => {
                                props.history.push('/institutions')
                            }}
                        >
                            キット発送
                        </MenuItem>
                    </Menu>
                ) : (
                    <Menu iconShape="circle">
                        <SubMenu
                            title={'施設・ユーザー等'}
                            icon={<FaHospitalUser />}
                            open={current === 2}
                            onClick={() => (current === 2 ? setCurrent(0) : setCurrent(2))}
                        >
                            <MenuItem
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/organizations'))
                                }}
                                icon={<FaRegBuilding />}
                            >
                                組織グループ
                            </MenuItem>
                            <MenuItem
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/institutions'))
                                }}
                                icon={<FaHospitalAlt />}
                            >
                                病院・クリニック
                            </MenuItem>
                            <MenuItem
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/doctors'))
                                    props.history.push('/doctors')
                                }}
                                icon={<FaRegAddressCard />}
                            >
                                医者
                            </MenuItem>
                            <MenuItem
                                icon={<FaUserAlt />}
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/patients'))
                                }}
                            >
                                ユーザー
                            </MenuItem>
                            <MenuItem
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/vendors'))
                                }}
                                icon={<FaBuilding />}
                            >
                                委託先
                            </MenuItem>
                            <MenuItem
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/sales_agencies'))
                                }}
                                icon={<BiSwim />}
                            >
                                営業代行
                            </MenuItem>
                        </SubMenu>
                    </Menu>
                )}

                <Menu iconShape="circle">
                    <SubMenu
                        title={'検品・冷蔵庫'}
                        icon={<FaClipboardCheck />}
                        open={current === 3}
                        onClick={() => (current === 3 ? setCurrent(0) : setCurrent(3))}
                        suffix={
                            <Badge bg={'danger'}>
                                {inspectionStatusGroupData
                                    .filter((d) => ['DRAFT', 'INPUTTED'].includes(d.name))
                                    .map((d) => d.count)
                                    .reduce((previous, current) => previous + current) || undefined}
                            </Badge>
                        }
                    >
                        <MenuItem
                            icon={<FaClipboardCheck />}
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/inspections/transportation_reports'))
                            }}
                            suffix={
                                <Badge bg={'danger'}>
                                    {inspectionStatusGroupData
                                        .filter((d) => ['DRAFT', 'INPUTTED'].includes(d.name))
                                        .map((d) => d.count)
                                        .reduce((previous, current) => previous + current) || undefined}
                                </Badge>
                            }
                        >
                            搬送履歴・検品
                        </MenuItem>
                        <MenuItem
                            icon={<FaBorderAll />}
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/freezers'))
                            }}
                        >
                            フリーザー
                        </MenuItem>
                        <MenuItem
                            style={{ display: isHomeTest ? 'none' : 'block' }}
                            icon={<FaSkull />}
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/request_form_errors'))
                            }}
                        >
                            検査依頼書不備報告
                        </MenuItem>
                    </SubMenu>
                </Menu>

                <Menu iconShape="circle">
                    <SubMenu
                        title={'検査'}
                        icon={<FaVial />}
                        open={current === 4}
                        onClick={() => (current === 4 ? setCurrent(0) : setCurrent(4))}
                        suffix={
                            <Badge bg={'danger'}>
                                {sampleStatusGroupData
                                    .filter((d) => !['DRAFT', 'INPUTTED'].includes(d.name))
                                    .map((d) => d.count)
                                    .reduce((previous, current) => previous + current) || undefined}
                            </Badge>
                        }
                    >
                        <MenuItem
                            icon={<FaVial />}
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/samples'))
                            }}
                            suffix={
                                <Badge bg={'danger'}>{sampleStatusGroupData.find((d) => (d.name as SampleStatus) === 'WAREHOUSED')?.count || undefined}</Badge>
                            }
                        >
                            検体
                        </MenuItem>
                        <MenuItem
                            icon={<FaSyringe />}
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/extractions'))
                            }}
                            suffix={
                                <Badge bg={'danger'}>
                                    {sampleStatusGroupData.find((d) => (d.name as SampleStatus) === 'RNA_EXTRACTED')?.count || undefined}
                                </Badge>
                            }
                        >
                            抽出・精製
                        </MenuItem>
                        <MenuItem
                            icon={<FaDna />}
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/dna'))
                            }}
                            suffix={
                                <Badge bg={'danger'}>
                                    {sampleStatusGroupData.find((d) => (d.name as SampleStatus) === 'DNA_SYNTHESIZED')?.count || undefined}
                                </Badge>
                            }
                        >
                            cDNA合成
                        </MenuItem>
                        <MenuItem
                            icon={<FaChessBoard />}
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/pcr_runs'))
                            }}
                            suffix={
                                <Badge bg={'danger'}>{sampleStatusGroupData.find((d) => (d.name as SampleStatus) === 'PCR_READY')?.count || undefined}</Badge>
                            }
                        >
                            qPCR
                        </MenuItem>
                    </SubMenu>
                </Menu>
            </Menu>
            <Menu iconShape="circle">
                <SubMenu title={'結果印刷'} icon={<FaBook />} open={current === 5} onClick={() => (current === 5 ? setCurrent(0) : setCurrent(5))}>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/send_histories'))
                        }}
                        suffix={
                            <Badge bg={'danger'}>{sampleStatusGroupData.find((d) => (d.name as SampleStatus) === 'PRINT_REQUESTED')?.count || undefined}</Badge>
                        }
                    >
                        スキャン
                    </MenuItem>
                    {(isHomeTest || process.env.REACT_APP_ENV === 'staging') && (
                        <MenuItem
                            onClick={(e) => {
                                stopPropagation(e, () => props.history.push('/navi/results'))
                            }}
                        >
                            ナビ
                        </MenuItem>
                    )}
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/lite/results'))
                        }}
                    >
                        ライト
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/check/results'))
                        }}
                    >
                        チェック
                    </MenuItem>
                </SubMenu>
            </Menu>

            <Menu iconShape="circle">
                <SubMenu title={'製品・QC管理'} icon={<FaRegSquare />} open={current === 6} onClick={() => (current === 6 ? setCurrent(0) : setCurrent(6))}>
                    <MenuItem
                        icon={<FaShieldVirus />}
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/product_items'))
                        }}
                    >
                        製品
                    </MenuItem>
                    <MenuItem
                        icon={<FaCheckCircle />}
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/qc_settings'))
                        }}
                    >
                        QC設定
                    </MenuItem>
                    <MenuItem
                        icon={<FaCheckCircle />}
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/product_items?scope=only_qc'))
                        }}
                    >
                        標準尿QC
                    </MenuItem>
                    <MenuItem
                        icon={<FaCheckCircle />}
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/standard_urines'))
                        }}
                    >
                        標準尿テーブル
                    </MenuItem>
                </SubMenu>
            </Menu>

            <Menu iconShape="circle">
                <SubMenu
                    title={'購買・在庫'}
                    icon={<MdOutlineInventory2 />}
                    open={current === 7}
                    onClick={() => (current === 7 ? setCurrent(0) : setCurrent(7))}
                >
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/orders'))
                        }}
                    >
                        プローブ発注・納品
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/probes'))
                        }}
                    >
                        プローブ一覧
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/probe_stocks'))
                        }}
                    >
                        プローブロット
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/reagents'))
                        }}
                    >
                        試薬
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/stocktakings'))
                        }}
                    >
                        棚卸し一覧
                    </MenuItem>
                </SubMenu>
            </Menu>
            <Menu iconShape="circle" style={{ display: isHomeTest ? 'none' : 'block' }}>
                <SubMenu title={'レポート'} icon={<FaFileAlt />} open={current === 8} onClick={() => (current === 8 ? setCurrent(0) : setCurrent(8))}>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/reports/ct_charts'))
                        }}
                    >
                        精度管理
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => {})
                        }}
                    >
                        温度管理
                    </MenuItem>
                </SubMenu>
            </Menu>
            <Menu iconShape="circle" style={{ display: isHomeTest ? 'none' : 'block' }}>
                <SubMenu title={'台帳'} icon={<FaBook />} open={current === 9} onClick={() => (current === 9 ? setCurrent(0) : setCurrent(9))}>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/equipments')
                            })
                        }}
                    >
                        機器一覧
                    </MenuItem>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledger/training')
                            })
                        }}
                    >
                        教育研修・技能評価記録台帳
                    </MenuItem>

                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledger/group_training')
                            })
                        }}
                    >
                        集合教育記録台帳
                    </MenuItem>

                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledgers/disposal_samples')
                            })
                        }}
                    >
                        廃棄処理台帳
                    </MenuItem>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledgers/reagents')
                            })
                        }}
                    >
                        試薬管理台帳
                    </MenuItem>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledgers/request_form_errors')
                            })
                        }}
                    >
                        検査依頼情報台帳
                    </MenuItem>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledgers/qc')
                            })
                        }}
                    >
                        統計学的精度管理台帳
                    </MenuItem>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledger/receive')
                            })
                        }}
                    >
                        検体受領・搬送作業日誌
                    </MenuItem>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledger/check_in')
                            })
                        }}
                    >
                        検体受付作業日誌
                    </MenuItem>
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/ledger/measure')
                            })
                        }}
                    >
                        測定作業日誌
                    </MenuItem>
                </SubMenu>
            </Menu>
            <Menu iconShape="circle">
                <SubMenu title={'営業管理'} icon={<FaChartLine />} open={current === 10} onClick={() => (current === 10 ? setCurrent(0) : setCurrent(10))}>
                    {!isHomeTest && (
                        <>
                            <MenuItem
                                icon={<FaShieldVirus />}
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/product_sets'))
                                }}
                            >
                                製品セット
                            </MenuItem>
                            <MenuItem
                                icon={<FaArrowDown />}
                                onClick={(e) => {
                                    stopPropagation(e, () => props.history.push('/discounts'))
                                }}
                            >
                                ディスカウント
                            </MenuItem>
                        </>
                    )}
                    <MenuItem
                        icon={<FaChartBar />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/sales')
                            })
                        }}
                    >
                        売上
                    </MenuItem>

                    <MenuItem
                        icon={<FaChartBar />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/sales/dashboard')
                            })
                        }}
                    >
                        状態別売上
                    </MenuItem>
                    <MenuItem
                        style={{ display: isHomeTest ? 'none' : 'block' }}
                        icon={<FaFileInvoiceDollar />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/invoices')
                            })
                        }}
                    >
                        請求
                    </MenuItem>
                    <MenuItem
                        style={{ display: isHomeTest ? 'none' : 'block' }}
                        icon={<FaFileInvoiceDollar />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/sales_agencies/payment')
                            })
                        }}
                    >
                        営業代行支払
                    </MenuItem>
                    <MenuItem
                        style={{ display: isHomeTest ? 'none' : 'block' }}
                        icon={<BsBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/materials')
                            })
                        }}
                    >
                        資材管理
                    </MenuItem>
                    <MenuItem
                        icon={<BsBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => {
                                props.history.push('/task_master_sets?kind=MATERIAL')
                            })
                        }}
                    >
                        資材タスク設定
                    </MenuItem>

                    <MenuItem
                        icon={<FaBarcode />}
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/coupons'))
                        }}
                    >
                        優待・クーポン
                    </MenuItem>
                </SubMenu>
            </Menu>
            <Menu iconShape="circle">
                <SubMenu title={'テスト'} icon={<FaPython />} open={current === 11} onClick={() => (current === 11 ? setCurrent(0) : setCurrent(11))}>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/pcr_test_runs'))
                        }}
                    >
                        PCRテストラン
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/tests/result_v2'))
                        }}
                    >
                        結果表v2テスト
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/tests/result_lite'))
                        }}
                    >
                        ライト結果表テスト
                    </MenuItem>
                    <MenuItem
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/tests/result_check'))
                        }}
                    >
                        チェック結果表テスト
                    </MenuItem>
                </SubMenu>
            </Menu>
        </>
    )

    const venderAppContent = (
        <>
            <Menu iconShape="circle">
                <MenuItem
                    icon={<FaBook />}
                    onClick={(e) => {
                        stopPropagation(e, () => props.history.push('/send_histories'))
                    }}
                >
                    スキャン結果表
                </MenuItem>
            </Menu>
            {isHomeTest && (
                <Menu iconShape="circle">
                    <MenuItem
                        icon={<FaBook />}
                        onClick={(e) => {
                            stopPropagation(e, () => props.history.push('/navi/results'))
                        }}
                    >
                        ナビ結果表
                    </MenuItem>
                </Menu>
            )}
            <Menu iconShape="circle">
                <MenuItem
                    icon={<FaBook />}
                    onClick={(e) => {
                        stopPropagation(e, () => props.history.push('/lite/results'))
                    }}
                >
                    ライト結果表
                </MenuItem>
            </Menu>
            {/* <MenuItem
                onClick={(e) => {
                    stopPropagation(e, () => props.history.push('/check/results'))
                }}
            >
                チェック
            </MenuItem> */}
        </>
    )

    return (
        <ProSidebar
            className="no-print"
            // image={Logo}
            collapsed={props.collapsed}
            // toggled={toggled}
            breakPoint="md"
            width={240}
            //   onToggle={handleToggleSidebar}
        >
            <SidebarHeader>
                <Flex flexDirection="column">
                    <div
                        style={{
                            height: 100,
                            position: 'relative',
                            width: '100%',
                        }}
                    >
                        <img
                            src={isHomeTest ? LogoRCE : Logo}
                            style={{
                                width: '100%',
                                objectFit: 'cover',
                                // position: 'absolute',
                                filter: isHomeTest ? 'none' : 'invert(50%) sepia(100%) saturate(0%) brightness(1000%) contrast(101%)',
                            }}
                        />
                        <div style={{ width: '100%', position: 'absolute', top: 73, left: 16, fontWeight: 'bold', fontSize: 14 }}>
                            {`ようこそ ${globalState.user.fullName}さん`}
                        </div>
                    </div>
                </Flex>
            </SidebarHeader>

            <SidebarContent>
                {isVender ? venderAppContent : craifAppContent}
                {/* <SubMenu title={intl.formatMessage({ id: 'multiLevel' })} icon={<FaList />}>
            <MenuItem>{intl.formatMessage({ id: 'submenu' })} 1 </MenuItem>
            <MenuItem>{intl.formatMessage({ id: 'submenu' })} 2 </MenuItem>
            <SubMenu title={`${intl.formatMessage({ id: 'submenu' })} 3`}>
              <MenuItem>{intl.formatMessage({ id: 'submenu' })} 3.1 </MenuItem>
              <MenuItem>{intl.formatMessage({ id: 'submenu' })} 3.2 </MenuItem>
              <SubMenu title={`${intl.formatMessage({ id: 'submenu' })} 3.3`}>
                <MenuItem>{intl.formatMessage({ id: 'submenu' })} 3.3.1 </MenuItem>
                <MenuItem>{intl.formatMessage({ id: 'submenu' })} 3.3.2 </MenuItem>
                <MenuItem>{intl.formatMessage({ id: 'submenu' })} 3.3.3 </MenuItem>
              </SubMenu>
            </SubMenu>
          </SubMenu> */}
            </SidebarContent>

            {/* <SidebarFooter style={{ textAlign: 'center' }}>
                <div
                    className="sidebar-btn-wrapper"
                    style={{
                        padding: '20px 24px',
                    }}
                >
                    <a href="https://github.com/azouaoui-med/react-pro-sidebar" target="_blank" className="sidebar-btn" rel="noopener noreferrer">
                        <FaGithub />
                        <span style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>view source</span>
                    </a>
                </div>
            </SidebarFooter> */}
        </ProSidebar>
    )
}

export default Aside
